<template>
    <div class="login-dialog__content-container d-flex justify-center pt-10">
        <div class="login-dialog__content-container--logo">
            <h2 class="login-dialog--login__content-container--text__title mb-3">{{title}}</h2>
            <h3 class="login-dialog--login__content-container--text__subtitle font-weight-bold">{{subtitle}}</h3>
            <p class="login-dialog__content-container--text">Så fint at du ønsker å benytte våre salonger og klinikker.</p>
            <p class="login-dialog__content-container--text">Vi lover å ivareta ditt personvern.</p>
            <p class="login-dialog__content-container--text">Ved å lage ny bruker hos oss godtar du våre <span href="#" class="text-decoration-underline font-weight-medium"><a @click="$emit('changeView', 'terms_of_use')">vilkår for bruk.</a></span></p>
            <span class="login-dialog--login__content-container--text__fine-print mb-10">Våre tjenester kan benyttes fra du er 15 år, men noen behandlinger krever at du er fyllt 18 år.</span>
        </div>
        <div class="login-dialog__content-container--options">
            <v-btn elevation="0" block height="44px" color="#472449" dark rounded class="my-3" @click="nextStep('insert-email')">
                Ny bruker
            </v-btn>
            <v-btn elevation="0" block height="44px" outlined color="#222222" dark rounded class="mb-3" @click="oauthCreate('google')">
                Ny bruker med <img :src="googleIcon" class="pt-1 pl-2" style="object-fit: contain;"/>
            </v-btn>
            <v-btn elevation="0" block height="44px" outlined color="#222222" dark rounded class="mb-3" @click="oauthCreate('apple')">
                Ny bruker med <img :src="appleIcon" class="pt-1 pl-2" style="object-fit: contain;"/>
            </v-btn>
            <v-btn elevation="0" block height="44px" outlined color="#222222" dark rounded class="mb-3" @click="oauthCreate('vipps')">
                Ny bruker med <img :src="vippsIcon" class="pt-1 pl-2" style="object-fit: contain;"/>
            </v-btn>
        </div>
    </div>
</template>
<script>
export default {
    name: "the-selection",
    props: {
        title: {
            required: true,
            default: ''
        },
        description: {
            required: false,
            default: ''
        },
        isProfile: {
            type: Boolean,
            required: false,
            default: false
        },
        subtitle: {
            required: false,
            default: ''
        },
        layout: {
            type: String,
            default: "chain",
            required: false,
        },
        oauthUrl: {
            Type: String,
            default: '',
            required: true
        }
    },
    data() {
        return {
            vippsIcon: require("../../../../../assets/img/vipps-logo-orange.png"),
            googleIcon: require("../../../../../assets/img/google-logo-login.svg"),
            appleIcon: require("../../../../../assets/img/apple-logo-black.svg"),
            fixitIcon: require('../../../../../assets/img/fixit-logo-white.png'),
        };
    },
    methods: {
        nextStep(state) {
            // Track selected method
            if (this.layout === 'portal' && !this.isProfile) {
                if (state === 'insert-email') {
                    window.CONFIG.google.sendEventButtonClick('create-new-user', 'Opprett ny bruker','' )
                }
            } 
            this.$emit("nextStep", state);
        },
        close() {
            this.$emit("close");
        },
        oauthCreate(type) {
            // Track selected method
            if (this.layout === 'portal' && !this.isProfile) {
                window.CONFIG.google.sendEventButtonClick('create-new-user-with-' + type, 'Opprett ny bruker med ' + type, '')
            } 
            let redirectUrl = window.location.origin + window.location.pathname;
            if (this.$route.query.action && this.$route.query.siteId && this.$route.query.customerId) {
              redirectUrl += `&siteId=${this.$route.query.siteId}&customerId=${this.$route.query.customerId}`
            }
            window.location.href = this.oauthUrl + `?oauthTarget=${type}&redirectUri=${encodeURIComponent(redirectUrl)}`
            // setTimeout(() => {
            //     child.postMessage({returnMessageTo: window.location.origin}, this.oauthUrl)
            // }, 500);
        }
    },
    async beforeCreate() {
        window.addEventListener("message", (event) => {
            if(event.origin == this.oauthUrl){
                this.$emit("startEmailVerification", event);
            }
        }, false);
    }
};
</script>
